import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const Header = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(2)} ${theme.spacing(1.5)} ${theme.spacing(2)}`};
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(0)}`};
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[400]};
`;

export const StartContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const TargetContainer = styled.span<{ $isUnderTarget: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme, $isUnderTarget }) =>
    $isUnderTarget ? theme.palette.error.dark : theme.palette.text.secondary};
`;

export const TargetText = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  color: inherit;
`;

export const List = styled.ul`
  padding: 0;
  margin: 0;

  list-style: none;
`;

export const ListItem = styled.li``;

export const WeekDayContainer = styled.button`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;
  width: 100%;
  min-height: 3.2rem;

  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(1.5)}`};
  margin: 0;

  border: none;
  background: transparent;
  text-align: left;

  ${({ as }) =>
    !as &&
    css`
      cursor: pointer;
    `};
`;

export const LabelContainer = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  flex: 1 0 auto;
  min-width: 0;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const LabelText = styled.span`
  min-width: 0;
`;

export const InfoIconContainer = styled.span`
  display: flex;
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.grey[600]};
  font-size: 1.6rem;
`;

export const StartIconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 2rem;
  width: 2rem;

  font-size: 1.6rem;
  color: ${({ theme }) => theme.palette.grey[600]};
  line-height: 62.5%;
`;

export const EndContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  overflow: hidden;
  min-width: 0;
  flex-shrink: 10;
`;
